import { C } from "@/helpers/global";

export class StudentWeeklyPlanChangeDayWorkCount {
    constructor(p) {
        this.id = C.Int(p.id);

        const dayWorkCount = (p.dayWorkCount || [])
            .map(r => ({
                day: r.day || r.dayDate || r.date,
                count: C.Int(r.count || r.minute || r.workMinute),
            }))
            .filter(r => r.day && C.Int(r.count) > 0);

        this.workCount = dayWorkCount.reduce((total, r) => {
            return total + C.Int(r.count);
        }, 0);

        this.dayWorkCount = JSON.stringify(dayWorkCount);
    }
}